export const LOADING_FORM_CONSULTATION = 'LOADING_FORM_CONSULTATION';
export const ERROR_FORM_CONSULTATION = 'ERROR_FORM_CONSULTATION';
export const RESET_FORM_CONSULTATION = 'RESET_FORM_CONSULTATION';
